export const GET_DASHBOARD_REQUEST = 'DASHBOARD/GET_DASHBOARD_REQUEST';
export const GET_DASHBOARD_SUCCESS = 'DASHBOARD/GET_DASHBOARD_SUCCESS';
export const GET_DASHBOARD_ERROR = 'DASHBOARD/GET_DASHBOARD_ERROR';
export const GET_USER_DASHBOARD_REQUEST = 'DASHBOARD/GET_USER_DASHBOARD_REQUEST';
export const GET_USER_DASHBOARD_SUCCESS = 'DASHBOARD/GET_USER_DASHBOARD_SUCCESS';
export const GET_USER_DASHBOARD_ERROR = 'DASHBOARD/GET_USER_DASHBOARD_ERROR';
export const GET_BRANCH_DASHBOARD_REQUEST = 'DASHBOARD/ GET_BRANCH_DASHBOARD_REQUEST';
export const GET_BRANCH_DASHBOARD_SUCCESS = 'DASHBOARD/  GET_BRANCH_DASHBOARD_SUCCESS';
export const GET_BRANCH_DASHBOARD_ERROR = 'DASHBOARD/  GET_BRANCH_DASHBOARD_ERROR';
